import React from 'react';
import { Button, useTranslate } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import cx from 'classnames';
import { time } from '~/utils';
import palette from '~/theme/palette';
import ReferenceField from '../ReferenceField';
import { getTypeOfIdentity } from '~/utils/identities';
import { useChangelog } from '~/hooks/useChangelogContext';
import { useEditMode } from '~/hooks/useEditModeContext';

const useStyles = makeStyles(() => ({
  rightContent: {
    flexGrow: 0,
    flexShrink: 0,
    width: '300px',
    minWidth: '300px',
    alignSelf: 'center',
    marginTop: '-8px',
    /* eslint-disable no-useless-computed-key */
    ['@media (min-width: 1280px)']: {
      width: '360px',
    },
  },
  changelogMode: {
    backgroundColor: palette.changelog.base,
  },
  rightContainer: {
    padding: '8px',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
  textField: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '& > div': {
      alignItems: 'center',
      '& > div': {
        width: '145px',
        justifyContent: 'center',
        textAlign: 'center',
        /* eslint-disable no-useless-computed-key */
        ['@media (min-width: 1280px)']: {
          width: '190px',
        },
      },
    },
  },
  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'inline',
  },
}));

const ChangelogPanel = () => {
  const classes = useStyles();
  const { editMode } = useEditMode();
  const { canView, changelogs, selectedId, goToPrev, goToNext, hasPrev, hasNext } = useChangelog();

  const translate = useTranslate();
  const t = (key: string, options?: any): string =>
    translate(`components.RecordTitle.${key}`, options);

  if (editMode !== 'CHANGELOG' || !canView) {
    return null;
  }

  const selected = changelogs.find((item) => item.id === selectedId);
  const originator = {
    id: selected?.originatorIdentity?.id ?? '',
    type: getTypeOfIdentity(selected?.originatorIdentity?.type ?? 'SYSTEM'),
  };

  return (
    <div className={classes.rightContent}>
      <Paper className={classes.changelogMode}>
        <Grid className={classes.rightContainer} container justify='space-between'>
          <Grid item>
            <Button label={t('prev')} onClick={goToPrev} disabled={!hasPrev}>
              <ChevronLeftIcon />
            </Button>
          </Grid>
          <Grid item>
            <ReferenceField
              className={cx(classes.textField, classes.ellipsis)}
              label={
                selected
                  ? t('version', { revision: selected.id, date: dateFormat(selected.timestamp) })
                  : ''
              }
              record={originator}
            />
          </Grid>
          <Grid item>
            <Button label={t('next')} alignIcon='right' onClick={goToNext} disabled={!hasNext}>
              <ChevronRightIcon />
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

const dateFormat = (dateString: string) => {
  return `${time(dateString).format('l')} ${time(dateString).format('LT')}`;
};

export default ChangelogPanel;
